import { toast } from "react-toastify";

export function handleAxiosError(error) {
  if (error.response) {
    console.error("Server responded with error:", error.response);
    if (error.response.status === 400) {
      toast.error(error.response.data);
    } else {
      toast.error(
        `Upload failed [${error.response.status}]: ${error.response.data}`
      );
    }
  } else if (error.request) {
    console.error("No response received. Network error:", error.request);
    toast.error("Network error. No response from server. File too large?");
  } else {
    console.error("Axios config or JS error:", error.message);
    toast.error("Unexpected error: " + error.message);
  }
}
